// The encounter page's ONE status (Antonin, 19 Oct: "there should be only one status, in the header, the soft chip").
// Mapped from fields the page already has; nothing invented:
//   provider signed (sign record, isSignedByNurse false)      -> "Signed"            success
//   appointment status Fulfilled (shown as Completed)         -> "Completed"         success
//   visit started (not before Start), otherwise               -> "Checked In" neutral (Antonin 1 Nov: "Encounter started" is not
//                                                                a status; the PM word for the started visit, in the grey chip,
//                                                                also with no appointment status known. Before Start the same
//                                                                word keeps the PM primary chip: Antonin asked for grey only
//                                                                once the visit has started)
//   before Start: the appointment's own status (PM naming)    -> e.g. "Arrived", "Booked", "No Show"   (PM semantic, the rail's soft blue for checked in)
//   before Start and no appointment status known              -> none
// A nurse-only sign is not a provider sign: it changes nothing here.
import type { StatusChipProps } from '@scripsteam/scrips-signal-ds';
import { pmStatusBucket, pmRailStatusSemantic, pmStatusLabel } from '@/lib/pm-appointment-status';

export interface VisitStatus {
  label: string;
  semantic: NonNullable<StatusChipProps['semantic']>;
}

export function visitStatus(input: { beforeStart: boolean; providerSigned: boolean; appointmentStatus?: string | null }): VisitStatus | null {
  const code = input.appointmentStatus?.trim() || undefined;
  if (input.providerSigned) return { label: 'Signed', semantic: 'success' };
  if (code && pmStatusBucket(code) === 'fulfilled') return { label: 'Completed', semantic: 'success' };
  if (!input.beforeStart) return { label: pmStatusLabel('CheckedIn'), semantic: 'neutral' };
  if (!code) return null;
  return { label: pmStatusLabel(code), semantic: pmRailStatusSemantic(code) };
}
